import type React from 'react';
import { useRef } from 'react';

import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { GuidService } from 'ui-components/services/guid-service';

import { ModalPortal } from '../../modal-portal';

import styles from './upsell-modal-layout.module.less';

type UpsellModalLayoutProps = {
  descriptionContent: React.ReactNode;
  footerContent: React.ReactNode;
  imageContent: React.ReactNode;
  onClose: () => void;
  onCancel?: () => void;
};

export const UpsellModalLayout = ({ descriptionContent, footerContent, imageContent, onClose, onCancel }: UpsellModalLayoutProps) => {
  const handleCancel = onCancel ?? onClose;
  const modalHeaderId = useRef(GuidService.newGuid()).current;

  return (
    <ModalPortal onCancel={handleCancel} onClose={onClose}>
      <Modal modalHeaderId={modalHeaderId} size='large'>
        <ModalHeader className={styles['modal-header']} id={modalHeaderId} />
        <ModalBody className={styles['upsell-modal-layout']}>
          <div className={styles['description-wrapper']}>
            <div className={styles.description}>{descriptionContent}</div>
            <div className={styles['description-footer']}>{footerContent}</div>
          </div>
          {imageContent}
        </ModalBody>
      </Modal>
    </ModalPortal>
  );
};
